(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityAttachmentList', activityAttachmentListComponent);

    function activityAttachmentListComponent(lodash, GenericModel) {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/activity-input/activity-attachment-list',
            link: function(scope) {
                const vm = scope.vm;
                console.log('activityAttachmentList', vm);
                scope.handleRemoveAttachment = function(attachment) {
                    const index = lodash.findIndex(vm.model.attachments, {select_id: attachment.select_id});
                    vm.model.attachments.splice(index, 1);
                };

                scope.preattached = {
                    loading: false
                };

                if (lodash.has(vm.options, 'attachmentOptions.preattached')) {
                    scope.preattached.loading = true;
                    const model = new GenericModel(vm.options.attachmentOptions.preattached.datasource.url);
                    const method = lodash.get(vm.options.attachmentOptions, 'preattached.datasource.method', 'create');
                    const datasourceModel = lodash.get(vm.options.attachmentOptions, 'preattached.datasource.params', {});
                    model[method]({}, {data: datasourceModel}).$promise.then((res) => { // eslint-disable-line no-unused-vars
                        if (lodash.get(vm.options.attachmentOptions, 'preattached.datasource.params.unique', false) === res.unique) {
                            lodash.set(vm.model, 'attachments', res.data);
                        }
                        scope.preattached.loading = false;
                    }, (err)=> {
                        console.log(err);
                        scope.preattached.loading = false;
                    });
                }
            }
        };
    }
})();